import { render, staticRenderFns } from "./ItemList.vue?vue&type=template&id=a9e6b2a4&scoped=true&"
import script from "./ItemList.vue?vue&type=script&lang=js&"
export * from "./ItemList.vue?vue&type=script&lang=js&"
import style0 from "./ItemList.vue?vue&type=style&index=0&id=a9e6b2a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e6b2a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9e6b2a4')) {
      api.createRecord('a9e6b2a4', component.options)
    } else {
      api.reload('a9e6b2a4', component.options)
    }
    module.hot.accept("./ItemList.vue?vue&type=template&id=a9e6b2a4&scoped=true&", function () {
      api.rerender('a9e6b2a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/ItemList.vue"
export default component.exports